/** @format */

import React from 'react';

interface DashboardCountCardProps {
	title: string;
	count?: number;
	onClick?: () => void;
}

const DashboardCountCard: React.FC<DashboardCountCardProps> = ({
	title,
	count,
	onClick,
}) => {
	const isZero = count === 0;

	return (
		<section className='SuperAdminContainer col-span-1'>
			<div className='flex gap-1 justify-between items-center'>
				<span className='text-lg font-semibold'>{title}</span>

				<span
					onClick={onClick}
					className={`rounded-sm px-2.5 py-1.5 transition-colors duration-200 flex md:flex-row flex-col 
          items-center justify-center active w-fit border font-semibold ${
						onClick ? 'cursor-pointer hover:bg-gray-300' : ''
					}
          ${
						isZero
							? 'bg-red-100 text-red-700 border-red-300'
							: 'bg-gray-200 text-myButtonBg border-gray-300'
					}`}>
					{count}
				</span>
			</div>
		</section>
	);
};

export default DashboardCountCard;
